import type { ReactElement, SVGProps } from "react";

export function CloseIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.29935 18.9077L5.1416 17.7L10.8166 12L5.1416 6.24999L6.29935 5.04224L12.0244 10.7922L17.6994 5.04224L18.8571 6.24999L13.1821 12L18.8571 17.7L17.6994 18.9077L12.0244 13.1577L6.29935 18.9077Z"
        fill="#16181D"
      />
    </svg>
  );
}
